import { Stack, Typography } from "@mui/material";
import { useObjectDefinitionContext } from "../ObjectDefinitionContext";
import ObjectSourceBadge from "../objects/ObjectSourceBadge";

const ObjectDetailsTitle = () => {
  const { objectDefinition } = useObjectDefinitionContext();

  return (
    <Stack spacing={0.5} sx={{ py: 1.5 }}>
      <Stack direction="row" spacing={1}>
        <Typography variant="h6">{objectDefinition.objectName}</Typography>
        <ObjectSourceBadge objectSource={objectDefinition.source} />
      </Stack>
      <Typography variant="caption" color="textSecondary">
        Object Definition
      </Typography>
    </Stack>
  );
};

export default ObjectDetailsTitle;
